export class Patterns {
  static email = /[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/
  static enTxt = '^[a-zA-Z ]+$';
  static arTxt = '^(?=.*[\u0600-\u06FF])[\u0600-\u06FF ]+$';
  static enTxt_Numbers = '^[a-zA-Z0-9 ]+$';
  static noSpecialTxt = '^[a-zA-Z\u0600-\u06FF ]+$';
  static number = '^[0-9]+$';
  static float = '([0-9]+[.])*[0-9]+(?:[0-9]+)?$';
  static float2decimal = /^\s*-?[1-9]\d*(\.\d{1,2})?\s*$/;
  static price2decimal = /^\s*?[0-9]\d*(\.\d{1,2})?\s*$/;
  static website = /(http|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
  static enTxtWithSpecial = "^[a-zA-Z0-9- !\"'@#$%^&*()<>?;_+.,:\|=/{}]+$"
  static arTxtWithSpecial = "^(?=.*[\u0600-\u06FF0-9- ])[\u0600-\u06FF0-9- !\"'@#$%^&*()<>?;_+.,:\|=/{}]+$"
  static price = '^[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*$'
  static numbers_plus = '^[\+]?[(]?[0-9]{1,3}[) ]?[-\s\.]?[0-9][-\s\.]?[0-9]{4,10}$'
  // static phoneNumber = '[+0-9]+'
  static phoneNumber = '^[+٠-٩0-9]+$';
  static saudiPhoneNumber = /^05\d{8}$/
  // static password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&*+={}?<>"'(),])(?!.*\s).{8,}$/
  static password = /^(?!.*[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF])(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%&*+={}?<>"'(),]).{8,}$/;
  static percentageTwoDigits = '^(0|[1-9][0-9]?)$';

  // static arTxtWithSpecial = "^(?=.*[\u0600-\u06FF])[\u0600-\u06FF0-9 !@#$%^&*()]+$"
  // static website = "(https://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-_]*/?";
}
